import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-762a5aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cancel-order-info-content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "shop-info" }
const _hoisted_5 = { class: "mb_12 pl_8 flex-ter" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "THECKB SKU：", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "mb_12 pl_8 flex-ter" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "reason" }
const _hoisted_12 = { value: "label" }
const _hoisted_13 = { class: "flex-1 line--only" }
const _hoisted_14 = { class: "footer" }

import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { querySystemCancelOrder, handleSystemCancelOrder, CancelOrderProps } from '@/apis/order'
import { isJA, useRtfix } from '@/store'
import { useRouter } from 'vue-router'
import { onMounted, computed, ref } from 'vue'
import { useStore } from 'vuex'
import Image from '@/components/common/Image.vue'
import QuestionReason from '@/views/usercenter/Order/AbnormalOrder/QuestionReason.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const isLogin = computed(() => store.getters.isLogin)
const customerShopId = computed(() => store.getters.curShop)
const visible = ref(false)

const router = useRouter()

// 取消订单列表
const cancelList = ref<CancelOrderProps[]>([])

// 查看取消订单
const checkCancelOrder = async () => {
  const productSkuList = cancelList.value.map(i => i?.productSku ?? '')
  const platformOrderNoList = cancelList.value.map(i => i?.platformOrderNo ?? '')
  sessionStorage.setItem('productSkuList', productSkuList.join(','))
  sessionStorage.setItem('platformOrderNoList', platformOrderNoList.join(','))
  await handleSystemCancelOrder({ abnormalOrderIds: cancelList.value.map(i => i?.abnormalOrderId ?? '') })
  visible.value = false
  router.push(useRtfix('AbnormalOrder', { query: { abnormal: 'ApplyCancel' } }))
}

onMounted(async () => {
  const cancelOrderShow = localStorage.getItem('cancelOrderShow')
  if (isLogin.value && customerShopId.value && isJA() && cancelOrderShow !== '1') {
    const res = await querySystemCancelOrder()
    localStorage.setItem('cancelOrderShow', '1')
    if (res.data?.length) {
      cancelList.value = res.data ?? []
      const ids = res.data?.map((i: any) => i?.abnormalOrderId ?? '')
      await handleSystemCancelOrder({ abnormalOrderIds: ids })
      setTimeout(() => {
        visible.value = true
      }, 1000)
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(CommonDialog, {
    "z-index": 3000,
    noHeader: false,
    "model-value": visible.value,
    hiddenClose: true,
    "destroy-on-close": "",
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false)),
    footer: false,
    className: "cancel-order-info-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "header",
          innerHTML: _unref(t)('您有X个sku被取消，请及时查看').replace('X', `<br /><span class='num'>${cancelList.value.length}</span>`)
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cancelList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "item"
            }, [
              _createVNode(Image, {
                class: "img",
                src: item?.productSkuImg || item?.productMainImg
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item?.productSku), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('取消数量')) + "：", 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(item?.cancelQuantity), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("data", _hoisted_12, _toDisplayString(_unref(t)('取消原因')) + "：", 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_tooltip, { effect: "customized" }, {
                      default: _withCtx(() => [
                        _createVNode(QuestionReason, {
                          item: item,
                          type: item?.processManner,
                          isTip: true
                        }, null, 8, ["item", "type"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: "close-btn btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
          }, _toDisplayString(_unref(t)('稍后查看')), 1),
          _createElementVNode("div", {
            class: "check-btn btn",
            onClick: checkCancelOrder
          }, _toDisplayString(_unref(t)('立即查看')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})